import { render, staticRenderFns } from "./table.vue?vue&type=template&id=91518f9e&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/domains/b2b/htdocs/local/templates/b2bmodern_default/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91518f9e')) {
      api.createRecord('91518f9e', component.options)
    } else {
      api.reload('91518f9e', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=91518f9e&", function () {
      api.rerender('91518f9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/vgt/table.vue"
export default component.exports